/**
 * @fileoverview Agent definition for plot-ideas-generator-v2.
 *
 * Creates three distinct, high-level plot concepts from story context.
 *
 * @category narrative.story.plot
 * @type primitive
 */

import type { AppAgentDefinition } from '@/domains/agents/schemas/agent';
import { InputSchema, OutputSchema } from './schema';
import { prompt } from './prompt';

export const definition: AppAgentDefinition = {
  id: 'plot-ideas-generator-v2',
  kind: 'primitive',
  name: 'Plot Idea Generator',
  description: 'Creates three distinct, high-level plot concepts from your story blurb.',
  category: 'plot',
  defaultPrompt: prompt,
  inputSchema: InputSchema,
  outputSchema: OutputSchema,
  metadata: {
    status: 'active',
    type: 'primitive',
    addedIn: '2025-01',
    lastUpdated: '2026-01',
    taxonomyPath: 'narrative.story.plot',
    usedBy: ['use-plot-ideation-v2.ts', 'plot-ideation-card.tsx'],
    relatedAgents: ['sequel-ideas-generator-v2', 'inspiration-ideas-generator-v2'],
  },
};
